/**
 * Functions for dealing with custom build configuration.
 */
import * as BuildConfig from '@/build-config.ts';

/** Require a custom JSON file if it exists */
export const custom = (filename: string, fallback: any = {}): any => {
  if (BuildConfig.NODE_ENV === 'test') return fallback;

  const modules = import.meta.glob('../custom/*.json', { eager: true });
  const key = `../custom/${filename}.json`;

  const module = modules[key];
  if (!module) return fallback;

  return 'default' in module ? module.default : module;
};
